import { CarerContractPresenter } from '@shared/modules/carer-contracts/carer-contract.presenter';
import { CarerPresenter } from '@shared/modules/carers/carer.presenter';
import type { Shift } from '@shared/modules/shifts/shift';
import { TeamPresenter } from '@shared/modules/teams/team-presenter';
import { DiaryEventPresenter } from '@shared/presenters/diary-event.presenter';
import { isBeforeNow } from '@shared/utils/date-time';
import { BookingPresenter } from '../bookings/booking.presenter';

export class ShiftPresenter extends DiaryEventPresenter<Shift> {

    get team(): TeamPresenter {
        return this.present('team.data', TeamPresenter);
    }

    get status() {
        if (this.data.attended) {
            return 'Attended';
        }

        const finish = this.start;

        if (finish && isBeforeNow(finish)) {
            return 'Not attended';
        }

        return 'Pending';
    }

    get isLocked() {
        return !this.isEditable;
    }

    get isEditable() {
        return !this.data.attended && !this.hasStarted;
    }

    get carer(): CarerPresenter {
        return this.present('carer.data', CarerPresenter);
    }

    get contract(): CarerContractPresenter {
        return this.present('contract.data', CarerContractPresenter);
    }

    get carerNotesHint() {
        return this.get('restrictions.data.can_update_carer_notes', true)
            ? 'Will be shown to the carer on their rota'
            : 'Read-only as shift is locked';
    }

    get bookings(): BookingPresenter[] {
        return this.presentCollection('bookings.data', BookingPresenter);
    }

    /*
     * Restrictions
     */

    get canUpdateTime() {
        return this.get('restrictions.data.can_update_time');
    }

    get cannotUpdateTime() {
        return !this.canUpdateTime;
    }

    get canUpdateCarerNotes() {
        return this.get('restrictions.data.can_update_carer_notes', true);
    }
}
